/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRegistrationV1AccountEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_REGISTRATION_V1_ACCOUNT_EVENT_ENTITY_NAME = 'ixc.registration.v1.AccountEvent';
export const ixcRegistrationV1AccountEventEntity = new schema.Entity<IxcRegistrationV1AccountEvent>(IXC_REGISTRATION_V1_ACCOUNT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcRegistrationV1AccountEvent) => `${entity.metadata?.eventId}` });

